<template >
  <div class="formPosition" v-role="'ped'">
    <v-overlay :value="progresso">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    <template>
 <v-container class="grey lighten-5">

   <v-row no-gutters>
     <v-col >
         <h4 style="text-align:center;"> <span>Mudanças de Curso e Classe</span></h4>

<div class="text-center">

<v-container fluid>
   <v-row align="center">

     <v-col class="d-flex" cols="3" sm="3">
         <v-text-field
           v-model="pesquisa"
           label="Informe o nome  ,  número de matricula( ou Bilhete )"
         ></v-text-field>
     </v-col>
     <v-col class="d-flex" cols="4" sm="2" >

         <v-btn :disabled="pesquisa === ''" color="primary" @click="Pesquisar()"><v-icon>search</v-icon></v-btn>

     </v-col>
    <v-col class="d-flex" cols="4" sm="4" >

          <div style="margin-left:10px;" v-if="this.$store.state.hasMessage" :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
         <label style="color:red" v-if="!msg_pesquisa">Estudante não encontrado!</label>

     </v-col>
     <v-col cols="12" sm="3">
         <v-menu :close-on-content-click="false"
     offset-x
     offset-y  >
     <template v-slot:activator="{ on }">
       <v-btn
         color="green darken-1"
         dark
         v-on="on"
         :disabled= !estudante_dados.length
       >
       <v-icon>settings</v-icon>
         Operações Estudante
       </v-btn>
     </template>

     <v-list>
       <!--v-if="( estudante_dados.length && estudante_dados[estudante_dados.length-1].classe !== '12ª Classe')" -->
       <v-list-item @click="mudanca_classe()">Solicitar Mudança de classe</v-list-item>
       <v-list-item v-if="( estudante_dados.length)" @click="mudanca_curso()">Mudança de curso</v-list-item>
       <v-list-item @click="ShowDialog()" :disabled="true">Habilitar à usuário</v-list-item>
      </v-list>
   </v-menu>
     </v-col>

   </v-row>
   <v-row>

       <v-col class="d-flex" cols="4" sm="5">

           <v-progress-linear v-if="progresso"
           color="green"
           indeterminate
           rounded
           height="3"
         ></v-progress-linear>
       </v-col>

   </v-row>

 </v-container>
   </div>
     </v-col>
   </v-row>
   <v-row>
     <v-col md="8"></v-col>
     <v-col md="3">
       <v-btn
          color="primary darken-1"
         dark
         to="pedidos-mudancas-admin"
         text
       >
       <v-icon>list</v-icon>
         Ver solicitações de mudanças
       </v-btn>
     </v-col>
   </v-row>

    <v-card
   class="mx-auto"
 >
   <v-list-item>
     <v-list-item-avatar color="grey"></v-list-item-avatar>
     <v-list-item-content>
       <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
       <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
     </v-list-item-content>
   </v-list-item>

<v-row>
 <v-col md="6">
   <v-card-text>
     <strong> Dados Pessoais</strong>
   </v-card-text>
   <hr>
   <v-row>
    <v-col md="12">
         <v-chip color="pink" style="margin:4px;color:white;">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
    </v-col>
    <v-col md="6">
         <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].idMatricula):''}}</v-chip>
    </v-col>
     <v-col md="6">
         <v-chip style="margin:4px">BI:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].bi):''}}</strong></v-chip>
    </v-col>
   </v-row>
   <v-row>
    <v-col md="4">
         <v-chip style="margin:4px">Genero:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].sexo):''}}</strong></v-chip>
    </v-col>
    <v-col md="8">
         <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].datanascimento):''}}</strong></v-chip>
    </v-col>
   </v-row>
    <v-row>
    <v-col md="6">
         <v-chip style="margin:4px">Natural de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
    </v-col>
   </v-row>

    <v-row>
    <v-col md="6">
         <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
    </v-col>
    <v-col md="6">
<v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip>

             </v-col>
   </v-row>

    <v-row>
    <v-col md="12">
       <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip>
             </v-col>

   </v-row>

   <hr>
 </v-col>
 <v-col md="6">
   <v-card-text>
     <strong> {{titulo}}</strong>
   </v-card-text>
   <hr>

   <v-data-table
           :headers="headers"
           :items="this.estudante_dados"
         >
     </v-data-table>

 </v-col>

</v-row>
 </v-card>
<!-- ================================ DIALOGO PARA HABILITAR UM ESTUDANTE COMO UM USUAIRO =========================-->
 <template>
               <v-row justify="center">

                     <v-dialog
                       v-model="dialog_show"
                       max-width="490"
                      >
                       <v-card>
                         <v-card-title class="headline">Habilitar Estudante à usuário</v-card-title>

                         <v-card-text>
                           <p> Deseja Habilitar este estudante à usuário? Fazendo isso , o estudante poderá acessar ao sistema fornecendo as suas credenciais.</p>
                         </v-card-text>

                         <v-card-actions>
                           <v-row>
                  <v-col md="10"></v-col>
                     <v-col md="2" v-if="progresso_3">
                       <v-progress-circular
                       :size="50"
                       color="green"
                       indeterminate
                     ></v-progress-circular>
                     </v-col>

               </v-row>
                           <v-spacer></v-spacer>

                           <v-btn
                             color="red darken-1"
                             text
                             @click="dialog_show = false"
                           >
                             Cancelar
                           </v-btn>

                           <v-btn
                             color="green darken-1"
                             text
                             @click="AddUser()"
                           >
                            Concordar
                           </v-btn>
                         </v-card-actions>
                       </v-card>
                     </v-dialog>
                   </v-row>
 </template>
<!-- ====================================FIM DA HABILITAÇÃO =================================================================-->

<!--==============================MUDANÇA DE CURSO - DIALOGO COM OS FORMULÁRIOS DA ESCOLHA DA TURMA ===================================================-->
<template>
       <v-row justify="center">
         <v-dialog v-model="dialog_curso2" persistent max-width="600px">
           <v-card>
             <v-card-title>
               <span class="headline">Mundança de Curso</span>
               <div style="margin-left:10px;" v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
             </v-card-title>
             <v-card-text>
               <v-container>
                 <v-row>
                   <v-col  cols="12" md="8">
                     <v-text-field
                       :rules="ruleTextRequired"
                       v-model="editedItem.nome"
                       label="Nome"
                       :disabled="true"
                     ></v-text-field>
                   </v-col>

                   <v-col cols="12" md="4">
                     <v-text-field
                     required
                       v-model="editedItem.bi"
                       :label="descricao"
                       :disabled="true"
                     ></v-text-field>
                   </v-col>

                 </v-row>
                 <v-row>

                 <v-col cols="12" md="6">
                     <v-combobox
                       v-if="true"
                         v-model="cursoSelecionado"
                         :rules="ruleRequired"
                         item-value="idCurso"
                         item-text="descricao"
                           @change="loadTurmaComb"
                           @click="loadTurmaComb"

                         :items="cursos_filtered"
                         chips
                         label="Curso"
                     ></v-combobox>
                   </v-col>

                   <v-col cols="12" md="6">
                     <v-combobox  id="turma"
                       v-model="turmaSelecionada"
                       :rules="ruleRequired"
                       item-value="pkTurma"
                       item-text="turmadescricao"
                       :items="turmasFiltered"
                       chips
                       label="Turma"
                     ></v-combobox>
                   </v-col>

     </v-row>

               </v-container>
             </v-card-text>
             <v-card-actions>
               <v-row>
                  <v-col md="10"></v-col>
                  <v-col md="2">
                     <v-progress-circular v-if="progresso"
                   :size="50"
                   color="green"
                   indeterminate
                 ></v-progress-circular>
                  </v-col>
               </v-row>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" text @click="closeDialogMudarCurso()">Cancelar</v-btn>
               <v-btn color="green darken-1" :disabled="!(turmaSelecionada && cursoSelecionado)" text @click="show_DialogmudarCurso()" >Confirmar</v-btn>
             </v-card-actions>
           </v-card>
         </v-dialog>
       </v-row>
 </template>


<!-- ================================DIALOGO DE MUDANÇA DE CURSO 1=================================================== -->


<!--==============================MUDANÇA DE CURSO - DIALOGO COM OS FORMULÁRIOS DA ESCOLHA DA TURMA ===================================================-->

 <template>
       <v-row justify="center">
         <v-dialog v-model="dialog_cursoResultado" persistent max-width="600px">
           <v-card>
             <v-card-title>
               <span class="headline">Mundança de Curso</span>
               <div style="margin-left:10px;" v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
             </v-card-title>
             <v-card-text>
                  <v-list rounded>
                       <v-subheader>Etapas para a realização da Mudança de Curso</v-subheader>
                       <v-row>
                       <v-col cols="12" md="6">
                     <v-combobox
                         v-model="cursoSelecionado"
                         :rules="ruleRequired"
                         item-value="idCurso"
                         item-text="descricao"
                           @change="loadTurmasChangeLesson()"
                         :items="cursos_filtered"
                         chips
                         label="Curso"
                     ></v-combobox>
                   </v-col>
                 </v-row>
                       <v-list-item-group
                         v-model="selectedItem"
                       >
                         <v-list-item
                           v-for="(item, i) in estudante_dados"
                           :key="i"
                         >
                         <v-row>
                   <v-col cols="12" sm="6" md="6">
                         <v-list-item-icon>
                             <v-combobox  
                           v-if="cursoSelecionado"
                             id="turma"
                             v-model="estudante_dados[estudante_dados.indexOf(item)].turma_uuid"
                             :rules="ruleRequired"
                             item-value="pkTurma"
                             item-text="turmadescricao"
                             :items="turmasMudancaCurso[i]"
                             chips
                             @change="turmaSelectedItem(item,i)"
                             label="Turma"
                         ></v-combobox>
                           </v-list-item-icon>
                           </v-col>
                           <v-col cols="12" sm="6" md="6">
                           <v-list-item-content>
                             <v-list-item-title >{{ ObterClasse(item.idAno_Academico) }} / {{ item.anoLectivo }} </v-list-item-title>
                           </v-list-item-content>
                         </v-col></v-row>
                           
                         </v-list-item>
                       </v-list-item-group>
                     </v-list>
             </v-card-text>
             <v-card-actions>
               <v-row>
                  <v-col md="10"></v-col>
                  <v-col md="2">
                     <v-progress-circular v-if="progresso"
                   :size="50"
                   color="green"
                   indeterminate
                 ></v-progress-circular>
                  </v-col>
               </v-row>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" text @click="closeDialogMudarCurso()">Cancelar</v-btn>
               <v-btn color="green darken-1" text @click="show_DialogmudarCurso()" :disabled="estudante_dados.length !== this.inscricaoMudancaCurso.length">Confirmar</v-btn>
             </v-card-actions>
           </v-card>
         </v-dialog>
       </v-row>
 </template>



 <!-- ========================Modal de Mudança de Classe=======================-->
   <template>
       <v-row justify="center">
         <v-dialog v-model="dialogo_classe" persistent max-width="600px">
           <v-card>
             <v-card-title>
               <span class="headline">Solicitar Mundança de Classe</span>
               <div style="margin-left:10px;" v-if="this.$store.state.hasMessage" :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
             </v-card-title>
             <v-card-text>
               <v-container>
                 <v-row>
                   <v-col cols="12" sm="6" md="6">
                     <v-text-field label="Nome do estudante" :disabled="true" v-model="editedItem.nome" ></v-text-field>
                   </v-col>
                   <v-col cols="12" sm="6" md="6">
                     <v-text-field label="Curso inscrito" :disabled="true" v-model="editedItem.descricao_curso"   ></v-text-field>
                   </v-col>
                   <v-col cols="12" sm="6" md="6">
                     <v-text-field
                       label="Classe Actual"
                        persistent-hint
                        :disabled="true"
                        v-model="editedItem.classe"
                     ></v-text-field>
                   </v-col>
                   <v-col cols="12" sm="6">
                     <v-combobox
                       v-model="anolectivo"
                       :rules="[v => !!v || 'Campo obrigatorio!']"
                       item-value="descricao"
                       item-text="novadescricao"
                       :items="anoslectivo"
                       filled
                       outlined
                       color="blue-grey lighten-2"
                       label="Selecione o ano lectivo"
                       @change="getTurmaByAnoLectivo()"
                     ></v-combobox>
                   </v-col>
                   <v-col cols="12" sm="6">
                     <v-select
                        outlined
                       :items= "Classes_filtradas"
                       label="Selecione a Nova Classe"
                       v-model="classe_selecionada"
                       @change="loadTurma()"
                       required
                       return-object
                     ></v-select>
                   </v-col>
                   <v-col cols="12" sm="6">
                     <v-select
                       outlined
                       :items="turmas_filtered"
                       v-model="turma_selecionada"
                       item-value="pkTurma"
                       item-text="turmadescricao"
                       label="Selecione a nova Turma"
                       @click="loadTurma()"
                     ></v-select>
                   </v-col>
                    <v-col cols="12" sm="6" md="12">
                     <v-text-field
                       label="Porquê desejas fazer a mudança?"
                        persistent-hint
                         v-model="motivo"
                     ></v-text-field>
                   </v-col>
                 </v-row>
               </v-container>
               <small >AnoLectivo( da ultima confirmação feita ):</small><strong>{{editedItem.anoLectivo}}</strong>
             </v-card-text>
             <v-card-actions>
               <v-row>
                  <v-col md="10"></v-col>
                  <v-col md="2">
                     <v-progress-circular v-if="progresso_2"
                   :size="50"
                   color="green"
                   indeterminate
                 ></v-progress-circular>
                  </v-col>
               </v-row>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" text @click="closeDialogMudarTurma()">Cancelar</v-btn>
               <v-btn color="green darken-1" :disabled="editedItem.nome === '' || editedItem.descricao_curso === '' || editedItem.classe === '' || classe_selecionada === '' || turma_selecionada === '' || motivo === '' " text @click="ConfirmarMudanca_classe()" >Confirmar</v-btn>
             </v-card-actions>
           </v-card>
         </v-dialog>
       </v-row>
 </template>
 <!-- ========================FIM  do Modal=====================================-->

 </v-container>

 </template>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'

const ls = require('local-storage')
export default {
 data: () => ({
   turmasMudancaCurso: [],
   inscricaoMudancaCurso: [],
   anolectivo: null,
   anoslectivo: [],
   isEtapa: false,
   dialog_show: false,
   dialog_cursoResultado: false,
   estudante_dados: [],
   idMatricula: null,
   msg_pesquisa: true,
   motivo: '',
   cursoSelecionado: null,
   dialogo_turma: false,
   idanolectivo: 0,
   dialogo_curso: false,
   dialogo_classe: false,
   classe_selecionada: '',
   classe_id: 0,
   turma_selecionada: '',
   pesquisa: '',
   turmaSelecionada: null,
   cursos: [],
   cursos_filtered: [],
   estudante: true,
   progresso: false,
   selectedItem: null,
   dialog_confirmar2: false,
   progresso_2: false,
   progresso_3: false,
   Pessoas: [],
   curso_selecionado_mc: '',
   turmasAll: [],
   turmas_filtered: [],
   turmas_filtered_mt: [],
   classesEstudante: [],
   dialog_curso: false,
   dialog_curso2: false,
   retornoMudanca: null,
   titulo: 'Historico Acadedémico',
   progress: false,
   Pessoas_filtro: [],
   Classes_filtradas: [],
   datebi: null,
   date: null,
   descricao: 'Nº do Bi',
   dialog_confirmar: false,
   dialogConfirmar: false,
   valid: true,
   menu: false,
   turmasAllAno: [],
   menubi: false,
   habilitaBi: false,
   showLink: false,
   overlay: false,
   cursosFiltrados: null,
   isLoading: true,
   nomeClasse: '',
   turmasFiltered: [],
   municipiosAll: [],
   itemAluno: null,
   cor: '',
   turmasAllFiltered: [],
   searchInDb: '',
   dialog: false,
   // eslint-disable-next-line standard/array-bracket-even-spacing
   classes: ['10ª Classe', '11ª Classe', '12ª Classe', '13ª Classe' ],
   ruleRequired: [value => value || 'campo obrigatorio'],

   defaultItem: {
     pkPessoa: 0,
     idPessoa: '',
     bi: '',
     idMunicipio: null,
     idPerfil: null,
     nome: '',
     morada: '',
     telefone: '',
     autor: '',
     datanascimento: '',
     data_: '',
     status_2: '',
     email: '',
     sexo: '',
     nomedopai: '',
     nomedamae: '',
     dataemissaobi: '',
     ResidenteEm: '',
     instituicao: '',
     instituicaodescricao: '',
     curso: null,
     turma: null,
     anoLectivo: '',
     idCurso: ''
   },
   editedItem:
   {
     nome: '',
     pkPessoa: '',
     idMatricula: '',
     bi: '',
     datanascimento: '',
     nomedopai: '',
     nomedamae: '',
     telefone: '',
     descricao_turma: '',
     instituicao: '',
     descricao_curso: '',
     anoLectivo: '',
     resultado: '',
     classe: '',
     idAno_Academico: '',
     idCurso: '',
     pkTurma: '',
     idAnoLectivo: 0,
     idTurma: '',
     idPessoa: '',
     idMAtricula: '',
     idMunicipio: null,
     idPerfil: null,
     morada: '',
     autor: '',
     data_: '',
     status_2: '',
     email: '',
     sexo: '',
     dataemissaobi: null,
     ResidenteEm: 1,
     instituicaodescricao: '',
     curso: null,
     turma: null,
     fkTurma: '',
     pkInscricao_na_turma: '',
     idano_academico: 0
   },

   items1: [
     'Aluno',
     'Funcionário'
   ],
   items2: [
     'Nome',
     'Bilhete de Identidade',
     'Número de Matricula'
   ],
   ano: [
     '2017',
     '2018',
     '2019',
     '2020'
   ],
   headers: [
     { text: 'Curso - Inscrito ', value: 'descricao_curso' },
     { text: 'Classes( Feitas )', value: 'classe' },
     { text: 'Turma', value: 'descricao_turma' },
     { text: 'Ano Lectivo', value: 'anoLectivo' },
     { text: 'Aproveitamento', value: 'resultado' }
   ],

 
   ruleTextRequired: [
     value => !!value || 'campo obrigatório.',
     value =>
       (value || '').length <= 50 || 'O máximo número de carácters atigidos',

     value => (value || '').length > 3 || 'carácteres insuficientes',
     value => {
       const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
       return !pattern.test(value) || 'Invalido.'
     }
   ]

 }),

 computed: {
   itIspossibleChangeLesson(){
     return (this.estudante_dados.filter(e=>e.idAno_Academico > 2)).length
   },
   idclasse () {
     return this.$store.state.idclasse
   },
   lsAnolectivo () {
     return ls.get('anolectivo')
   },
   role () {
     return ls.get('role')
   }
 },
 created () {
   // check if classe has been selected otherwise send back to painel to select
   this.loadAnolectivo()
   this.initializeCursos()
   this.ObterIdAnoLectivo()
 },
 methods: {


   getTurmaByAnoLectivo(){
     if(this.anolectivo)
     this.initializeturmasAllAnolectivo(this.anolectivo.descricao)
   else
   Swal.fire('Informação', 'Selecione o ano lectivo', 'warning')
   },
   closeDialogMudarTurma(){
     this.estudante_dados = []
     this.anolectivo = null
     this.turma_selecionada = null
     this.classe_selecionada = null
     this.editedItem = this.defaultItem
     this.motivo = null
     this.dialogo_classe = false
   },
   async loadAnolectivo () {
     try {
       this.anoslectivo = await axios
         .get('/listarAnoLectivoAll')
         .then(res => res.data)
     } catch (error) {
       Swal.fire('Informação', 'Ocorreu um erro', 'error')
     }
   },

   async ConfirmarMudanca_classe () {
     this.progresso_2 = true
     this.ObterIdClasse(this.classe_selecionada)
     let params =
       {
         nome: this.editedItem.nome,
         idMudanca: 0,
         bi: this.editedItem.bi,
         resultado: this.editedItem.resultado,
         idAno_Academico: this.editedItem.idAno_Academico,
         fkTurma: this.editedItem.pkTurma,
         idCurso: this.editedItem.idCurso,
         idMatricula: this.editedItem.idMatricula,
         operacao: 1,
         fkTurma_novo: this.turma_selecionada,
         idanoacademico_novo: this.classe_id,
         descricao_operacao: 'Solicitacão de mundança de Classe',
         idCursoNovo: null,
         AutorAdmin: null,
         idanolectivo: this.anolectivo.idAnoLectivo,
         fkPessoa: this.editedItem.pkPessoa,
         idTurma: this.editedItem.idTurma,
         mensagem_instituicao: this.motivo,
         mensagem_admin: null,
         anolectivo: this.anolectivo.descricao,
         pkInscricao_na_turma: 0 //Significa que é um insert e não um update pkInscricao_na_turma=0;Quando update,o obtem o valor da view
       }
     try {
       let msg = await axios
         .post('/mudancaInsertOrUpdate', params)
         .then(res => res.data)
         Swal.fire('Informação', 'A sua solicitação de Mudança foi enviada ao Administrador , aguarde a confirmação', 'success')
       this.progresso_2 = false
     } catch (error) {
       this.progresso_2 = false
       Swal.fire('Informação', 'Ocorreu um erro', 'error')
     } finally {
       this.closeDialogMudarTurma()
     }
     this.progresso_2 = false
   },

// *****************************************************Mudar de curso*******************************************************************   
   
   mudanca_curso () {
     
     if (this.estudante_dados.length === 1) {
       this.editedItem = Object.assign({}, this.estudante_dados[0])
       this.dialog_curso2 = true
       this.cursos_filtered = this.cursos.filter(c => c.idCurso !== this.editedItem.idCurso)
     } else
     if (this.estudante_dados.length > 1) {
       this.pesquisarClassesEstudante()
       this.dialog_cursoResultado = true
       this.cursos_filtered = this.cursos.filter(c => c.idCurso !== this.estudante_dados[0].idCurso)
     }
     this.initializeturmasAllAnolectivo(this.estudante_dados[0].anoLectivo)
   },
   
   closeDialogMudarCurso(){
     this.estudante_dados = []
     this.inscricaoMudancaCurso = []
     this.turmasMudancaCurso = []
     this.editedItem = this.defaultItem
     this.turmaSelecionada = null
     this.cursoSelecionado = null
     this.dialog_curso2 = false
     this.dialog_cursoResultado = false
   },
   show_DialogmudarCurso (){
     Swal.fire({
         title: "Informação",
         text: 'Ao Continuar esta operação,algumas notas serão perdidas e não será possivel reverter a operação!',
         showDenyButton: true,
         confirmButtonText: "Continuar",
         denyButtonText: `Cancelar`
       }).then((result) => {
         /* Read more about isConfirmed, isDenied below */
         if (result.isConfirmed) {
           
           if(this.dialog_cursoResultado) this.mudarCursoVariasInscricoes()
           else
           if(this.dialog_curso2) this.saveCurso()
           this.dialog_curso2 = false
           
         } else if (result.isDenied) {
           this.closeDialogMudarCurso()
         }
       });
   },
   async turmaSelectedItem(item, indice){
    if(item.turma_uuid){
       let params =
                {
                  idmatricula: item.idMAtricula,
                  idturma: item.turma_uuid.idTurma,
                  pkPessoa: item.pkPessoa,
                  idanolectivo: item.turma_uuid.anoLectivo,
                  pkTurma: item.turma_uuid.pkTurma,
                  idcurso: item.turma_uuid.idCurso,
                  bi: item.bi,
                  idanoacademico: item.turma_uuid.idAno_Academico,
                  resultado: (item.resultado === 'Transita') ? 1 : 0,
                  descricao_resultado: item.resultado,
                  fromtransferencia: 0,
                  turma_antiga: item.fkTurma,
                  pkInscricao_na_turma: item.pkInscricao_na_turma,
                  pkTurmaActual: item.turma_uuid.pkTurma,
                  idanoAcademicoActual: item.turma_uuid.idAno_Academico,
                  anolectivo: item.turma_uuid.anoLectivo
                }
     this.inscricaoMudancaCurso[indice] = params
    } else {
     Swal.fire('Informação', 'Selecione a respectiva turma', 'warning')
    }
     
   },

  async loadTurmasChangeLesson(){    
   try {      
     this.estudante_dados.forEach(async element => {
       await this.initializeturmasAllAnolectivo(element.anoLectivo)
     this.turmasMudancaCurso.push(this.turmasAll.filter(t => t.idCurso === this.cursoSelecionado.idCurso && t.idAno_Academico === element.idAno_Academico))
     });
         } catch (error) {
           Swal.fire('Informação', 'Ocorreu um erro ao carregar as turmas', 'error')
   }
     

   },
   async saveCurso () {
     if (this.editedItem && this.cursoSelecionado && this.turmaSelecionada) {
       this.progresso = true
       this.overlay = true
       this.dialog_confirmar = false
       this.dialogConfirmar = false
       let params =
               {
                 idmatricula: this.editedItem.idMAtricula,
                 idturma: this.turmaSelecionada.idTurma,
                 pkPessoa: this.editedItem.pkPessoa,
                 idanolectivo: this.turmaSelecionada.anoLectivo,
                 pkTurma: this.turmaSelecionada.pkTurma,
                 idcurso: this.cursoSelecionado.idCurso,
                 bi: this.editedItem.bi,
                 idanoacademico: this.turmaSelecionada.idAno_Academico,
                 resultado: (this.editedItem.resultado === 'Transita') ? 1 : 0,
                 descricao_resultado: this.editedItem.resultado,
                 fromtransferencia: 0,
                 turma_antiga: this.editedItem.fkTurma,
                 pkInscricao_na_turma: this.editedItem.pkInscricao_na_turma,
                 pkTurmaActual: this.editedItem.fkTurma,
                 idanoAcademicoActual: this.editedItem.idano_academico,
                 anolectivo: this.editedItem.anoLectivo
               }

       try {
         let msg = await axios
           .post('/MudarCursoInsertOrUpdate', params)
           .then(res => res.data)
         this.progresso = false
         if (!msg.length) {
           this.initializeCursos()
           Swal.fire('Informação', 'Mudança de curso efectuada com sucesso', 'success')
           this.overlay = false
         } else {
           Swal.fire('Informação', 'Ocorreu um erro', 'error')
         }
         this.dialog_curso = false
         this.progresso = false
         this.overlay = false
       } catch (error) {
         this.progresso = false
         Swal.fire('Informação', 'Ocorreu um erro ao mudar de curso', 'error')
       } finally {
         this.closeDialogMudarCurso()
       }
     }
   },

   async mudarCursoVariasInscricoes () {
       this.progresso = true
       this.overlay = true
       this.dialog_confirmar = false
       this.dialogConfirmar = false
       try {
         let msg = await axios
           .post('/MudarCursoInsertOrUpdateListInscricoes', this.inscricaoMudancaCurso)
           .then(res => res.data)
         this.progresso = false
         if (!msg.length) {
           this.initializeCursos()
           Swal.fire('Informação', 'Mudança de curso efectuada com sucesso', 'success')
           this.overlay = false
         } else {
           Swal.fire('Informação', 'Ocorreu um erro', 'error')
         }
         this.dialog_curso = false
         this.progresso = false
         this.overlay = false
       } catch (error) {
         this.progresso = false
         Swal.fire('Informação', 'Ocorreu um erro ao mudar de curso', 'error')
       } finally {
         this.closeDialogMudarCurso()
       }
     
   },
// ***************************************************************************************
async  Pesquisar () {
     try {
       this.progresso = true
       this.estudante_dados = await axios
         .get('/PesquisaLocalMudancaCurso/' + this.pesquisa)
         .then(res => res.data)
       this.progresso = false
       if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
     } catch (error) {
       this.progresso = false
     }
   },
   ObterClasse (idClasse) {
     if (idClasse === 1) { return '10ª Classe' }
     if (idClasse === 2) { return '11ª Classe' }
     if (idClasse === 3) { return '12ª Classe' }
     if (idClasse === 4) { return '13ª Classe' }
   },
   retornaClasse (idClasse) {
     if (idClasse[0].classe === 1) { this.nomeClasse = '10ª Classe' }
     if (idClasse[0].classe === 2) { this.nomeClasse = '11ª Classe' }
     if (idClasse[0].classe === 3) { this.nomeClasse = '12ª Classe' }
     if (idClasse[0].classe === 4) { this.nomeClasse = '13ª Classe' }
     this.pesquisarClassesEstudante().then(() => {
       this.dialog_cursoResultado = true
       this.dialog_curso2 = false
     })
   },
   show_mudarCurso () {
     this.dialogo_curso = true
     this.cursos_filtered = this.cursos.filter(c => c.idCurso !== this.editedItem.idCurso)
   },
   
   ObterIdClasse (classe) {
     if (classe === '10ª Classe') { this.classe_id = 1 } else if (classe === '11ª Classe') { this.classe_id = 2 } else if (classe === '12ª Classe') { this.classe_id = 3 } else if (classe === '13ª Classe') { this.classe_id = 4 }
   },

   ShowDialog () {
     this.dialog_show = true
   },
   async initializeturmasAllAnolectivo (anoLectivo) {
     this.progresso = true
     this.overlay = true
     try {
       this.turmasAll = await axios
         .get('/turmaFindAllAno/' + anoLectivo)
         .then(res => res.data)
       this.progresso = false
       this.overlay = false
     } catch (error) {
       this.progresso = false
       this.overlay = false
       Swal.fire('Informação', 'Ocorreu um erro ao carregar as turmas', 'error')
     }
   },
   loadTurma () {
     let valor = 0
     if (this.classe_selecionada === '10ª Classe') { valor = 1 } else if (this.classe_selecionada === '11ª Classe') { valor = 2 } else if (this.classe_selecionada === '12ª Classe') { valor = 3 } else if (this.classe_selecionada === '13ª Classe') { valor = 4 }

     this.turmas_filtered = this.turmasAll.filter(t => t.idCurso === this.editedItem.idCurso && t.idAno_Academico === valor)
   },
   loadTurmaComb (curso) {
     this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso && t.idAno_Academico === this.editedItem.idAno_Academico)
     this.$nextTick(() => { this.editedItem.turma = undefined })
   },

   async ObterIdAnoLectivo () {
     try {
       this.idanolectivo = await axios
         .get('/ObterIdAnoLectivo/' + ls.get('anolectivo'))
         .then(res => res.data)
     } catch (error) {
       Swal.fire('Informação', 'Ocorreu um erro', 'error')
     }
   },

   Classe (idClasse) {
     if (idClasse === '10ª Classe') { return 1 }
     if (idClasse === '11ª Classe') { return 2 }
     if (idClasse === '12ª Classe') { return 3 }
     if (idClasse === '13ª Classe') { return 4 }
   },

   mudanca_classe () {
     this.dialogo_classe = true
     this.editedItem = Object.assign({}, this.estudante_dados[0])
     this.Classes_filtradas = this.classes.filter(p => p !== this.editedItem.classe)
   },

   async pesquisarClassesEstudante () {
     try {
       this.classesEstudante = await axios
         .get('/estudante-classes/' + this.estudante_dados[0].idMAtricula)
         .then(res => res.data)
     } catch (error) {
       Swal.fire('Informação', 'Ocorreu um erro ao pesquisar', 'error')
     }
   },
   
   async AddUser () {
     this.progresso_3 = true

     let params =
        {
          pkUsuario: 0,
          email: this.estudante_dados[0].nome,
          role: 'ROLE_EST',
          password: '1234',
          enable: 0,
          instituicao_descricao: ls.get('instituicaodescricao'),
          nome: this.estudante_dados[0].nome,
          idPessoa: this.estudante_dados[0].idMatricula

        }

     try {
       let corMensagem = 'msgError'
       let msg = await axios
         .post('/UsuarioInsertOrUpdate', params)
         .then(res => res.data)

       if (msg.length) {
         Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação.', 'error')
       } else {
         this.text = 'Operação efectuada com sucesso.'
         Swal.fire('Informação', 'Operação efectuada com sucesso.', 'success')
         this.dialog_show = false
       }
       
       this.progresso = false
       this.progresso_3 = false
     } catch (error) {
       this.progresso = false
       this.progresso_3 = false
       this.text = error
     } finally {
       this.progresso = false
       this.progresso_3 = false
     }
   },
   async initializeCursos () {
     try {
       this.cursos = await axios
         .get('/cursoFindAll')
         .then(res => res.data)
     } catch (error) {
       Swal.fire('Informação', 'Ocorreu um erro ao carregar os cursos', 'error')
     }
   }

 }

}

</script>
